import { render } from "./AddLink.vue?vue&type=template&id=0835f5f7"
import script from "./AddLink.vue?vue&type=script&lang=js"
export * from "./AddLink.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__